<template>
    <div class="main-content " v-cloak>
        <div class="container">
            <div class="tab-items">
                <div class="tab-item-container">
                    <a @click="$router.push({ path: '/settings/account' })" class="tab-item-link" href="javascript:{}"
                        ><span class="icon-account"></span>Account
                        <div class="trial" v-if="user && user.active_plan && user.active_plan.is_trial">(Trial)</div>
                        <div
                            class="trial"
                            v-if="user && user.active_plan && !user.active_plan.id && user.free_trial_used"
                        >
                            (Trial over)
                        </div>
                    </a>
                </div>
                <div class="tab-item-container">
                    <a class="tab-item-link" @click="$router.push({ path: '/settings/contact' })" href="javascript:{}"
                        ><span class="icon-phone-bg"></span>Contact info</a
                    >
                </div>
                <div class="tab-item-container">
                    <a
                        class="tab-item-link"
                        @click="$router.push({ path: '/settings/change-password' })"
                        href="javascript:{}"
                        ><span class="icon-lock"></span>Change password</a
                    >
                </div>
                <div class="tab-item-container">
                    <a @click="delete_account()" class="tab-item-link red" href="javascript:{}"
                        ><span class="icon-delete"></span>Delete account</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "settings",
    components: {},
    data() {
        return {};
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.get_logged_in_user();
            next();
        });
    },
    computed: {
        ...mapState(["user"])
    },
    mounted() {},
    methods: {
        ...mapActions(["delete_user", "get_logged_in_user"]),
        delete_account() {
            if (confirm("Are you sure?")) {
                this.delete_user();
            }
        }
    },
    created() {}
};
</script>
<style scoped>
@media (max-width: 82rem) {
    .main-content {
        padding: 2.4rem 1.6rem 0 1.6rem;
    }
}

.tab-items .tab-item-link,
.tab-items .tab-item-link:hover,
.tab-items .tab-item-link:active,
.tab-items .tab-item-link:visited {
    font-size: 1.4rem;
    line-height: 2.4rem;
    align-items: center;
    letter-spacing: 0.03em;
    display: flex;
    text-decoration: none;
    color: #000000;
    padding: 1.6rem 1.6rem 1.6rem 0rem;
}

.tab-items .tab-item-link.red,
.tab-items .tab-item-link.red:hover,
.tab-items .tab-item-link.red:active,
.tab-items .tab-item-link.red:visited {
    color: #d30000;
}

.tab-item-container {
    display: flex;
    align-items: center;
}

.btn-primary {
    padding: 0.4rem 1.6rem;
    margin-left: auto;
    align-items: flex-start; /* NEW */
}

.trial {
    margin-left: 0.6rem;
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}

.tab-items .tab-item-link span {
    margin-right: 2rem;
}
</style>
